import React, { Fragment } from 'react';

const ActionIconsUsage = () => (
  <Fragment>
    <section>
      <article className="flex-justify-end flex-row last">
        <div className="left">
          <h1 className="h1 page-title">
            Actionable icons are simillar to buttons, but only using the visual interpretation.
          </h1>
        </div>
        <div className="right copy-content">
          <p>The UI when active will display red color for primary actions, and should be used when there are actions of high importance to the user, usually, these actions will affect the flow.</p>
          <p>On the other hand, the UI will be the black color for secondary actions, as these actions are of less importance to the user.</p>
        </div>
      </article>
    </section>
    <section className="bg-grey flex-grow-1 with-padding">
      <article className="flex-row flex-justify-end">
        <div className="right copy-content">
          <h2 className="h2 page-subtitle">Action Icons</h2>
          <p>These actionable icons are used with similar behavior as buttons but only using the visual interpretation without the need for text labeling.</p>
          <h2 className="h2 page-subtitle">Action Icons Navigations</h2>
          <p>Used to describe roles and also use generic words/expressions related to accounts or sections.</p>
        </div>
      </article>
    </section>
  </Fragment>
);

export default ActionIconsUsage;


// WEBPACK FOOTER //
// ./src/containers/elements/ActionIcons/ActionIconsUsage.js